import { Component, OnInit } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { Race } from '../race';
import { filter, map, shareReplay, switchMap, tap } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { RankingsService } from '../../rankings/rankings.service';
import { AppService } from '../../../app.service';
import { Ranking } from '../../rankings/ranking';

@Component({
  selector: 'mc-race-rankings',
  templateUrl: './race-rankings.component.html',
  styleUrls: ['./race-rankings.component.scss']
})
export class RaceRankingsComponent implements OnInit {

  race$: Observable<Race> = this.activatedRoute.parent.data.pipe(
    switchMap((data) => data.race$ as Observable<Race>),
    shareReplay({
      refCount: true,
      bufferSize: 1
    })
  );

  rankings$ = this.rankingsService.rankings$;

  lapsTail$ = this.race$.pipe(
    switchMap((race) => combineLatest([
      race.results$.pipe(
        map((results) => results.slice(-10)),
        filter((results) => results.length > 0)
      ),
      race.driversByStartNumber$
    ]))
  ).pipe(
    map(([results, drivers]) => {
      return results.map((result) => ({
        result,
        driver: drivers[result.driverId]
      }));
    }),
    shareReplay({
      refCount: true,
      bufferSize: 1
    })
  );

  currentGroupId$: Observable<number | string> = this.lapsTail$.pipe(
    map((laps) => {
      const groupId = Object.entries<number>(
          laps
            .map((lap) => lap.driver.features?.group + '')
            .reduce((counters, group) => {
              counters[group] = (counters[group] || 0) + 1;
              return counters;
            }, {})
        )
        .reduce((biggest, counter) => {
          if (!biggest) {
            return counter;
          } else if (counter[1] > biggest[1]) {
            return counter;
          } else {
            return biggest;
          }
        })[0];
      return groupId;
    }),
    tap(() => setTimeout(() => this.appService.fixView(), 1)),
    shareReplay({
      refCount: true,
      bufferSize: 1
    })
  );

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly rankingsService: RankingsService,
    private readonly appService: AppService,
    private readonly router: Router
  ) { }

  relativeRouterPath(ranking: Ranking) {
    return [ranking.id];
  }

  ngOnInit() {
    // this.router.navigate()
  }

}
